export const ROUTES = {
  auth: {
    actor_registration: `/auth/actor-registration`,
    director_registration: `/auth/director-registration`,
    sign_in: '/auth/sign-in',
    password_recovery: '/auth/password-recovery'
  },
  favorites: '/favorites',
  settings: '/settings',
  support: '/support',
  notifications: '/notifications',
  not_found: '/not-found',
  root: '/',
  change_email: '/change-email',
  change_phone: '/change-phone',
  /** Публичная страница видео по share-токену */
  public_video: '/v/:token'
} as const;

/** ID табов в настройках (query param act) */
export const SETTINGS_ACTS = {
  notifications: 'notifications',
  phone_number: 'phone_number',
  email: 'email',
  change_password: 'change_password',
  delete_profile: 'delete_profile'
} as const;

/**
 * Формирует URL настроек с указанным активным табом
 * @param act Раздел настроек
 */
export const getSettingsActUrl = (act: string) =>
  `${ROUTES.settings}?act=${act}`;
